<template>
  <f7-card class="card-raised" style="height: 100%; display: flex; flex-direction: column;">
    <slot></slot>
    <f7-card-content :padding="false" class="video-container" style="padding-bottom: 0; height: 100%;">
      <iframe :src="src + '?autoplay=false'" :title="title" loading="lazy" style="border: none; position: absolute; top: 0; height: 100%; width: 100%;" allow="accelerometer; gyroscope; encrypted-media; picture-in-picture;" allowfullscreen="true"  class="video-frame"></iframe>
    </f7-card-content>
  </f7-card>
</template>

<script>

  export default {
    components: {},

    props: ['src', 'title'],

    mixins: [],

    data: function () {
      return {
        //
      };
    },

    computed: {
      //
    },

    created() {
      //
    },

    mounted() {
      //
    },

    methods: {
      //
    },

    watch: {
      //
    }
  };
</script>
